import { render } from "./HerderView.vue?vue&type=template&id=21794dec"
import script from "./HerderView.vue?vue&type=script&lang=js"
export * from "./HerderView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__